<template>
	<div v-if="playbook" class="c-view">
		<InternalHeader>
			<div slot="title" class="c-internal-header__title">
				<a @click="$router.push('/playbooks')">
					<Icon :custom="'icon icon-arrow-left-1'"></Icon>
					Playbooks
				</a>
				/
				<a
					@click="
						$router.push(
							'/playbooks/' + playbook.id + '/summary-instances'
						)
					"
				>
					{{ playbook.name }}
				</a>
				/ Performance
			</div>
		</InternalHeader>
		<Row class="mt-5" :gutter="16">
			<Col span="6">
				<playbook-subnav :playbook-id="playbookId"></playbook-subnav>
			</Col>
			<Col span="18">
				<playbook-status
					:value="playbook.status_id"
					@update="mixinPlaybook_savePlaybook"
				></playbook-status>
				<Card dis-hover>
					<playbook-performance-form
						:playbook="playbook"
						:parameters="parameters"
					></playbook-performance-form>
				</Card>
				<Card class="mt-5" dis-hover v-if="0 && parameters">
					<playbook-performance-compare-form
						:parameters="parameters"
					></playbook-performance-compare-form>
				</Card>
				<playbook-performance-report
					class="mt-10"
					v-if="this.parameters.metric"
					:key="this.parameters.metric"
					:definition="this.parameters"
					:data-cache="{ playbook: playbook }"
				></playbook-performance-report>
			</Col>
		</Row>
	</div>
</template>

<script>
import Playbook from "@/js/mixins/playbook.js";
import PlaybookPerformanceReport from "@/js/lookups/playbook-performance-report";

export default {
	props: {},
	mixins: [Playbook],
	data() {
		return {
			parameters: null,
		};
	},
	components: {
		InternalHeader: function() {
			return import("@/js/components/partials/header");
		},
		PlaybookPerformanceForm: function() {
			return import("@/js/components/partials/playbook-performance-form");
		},
		PlaybookPerformanceCompareForm: function() {
			return import(
				"@/js/components/partials/playbook-performance-compare-form"
			);
		},
		PlaybookPerformanceReport: function() {
			return import(
				"@/js/components/partials/widgets/playbook-performance-report"
			);
		},
		PlaybookStatus: function() {
			return import("@/js/components/partials/playbook-status");
		},
		PlaybookSubnav: function() {
			return import("@/js/components/partials/playbook-subnav");
		},
	},
	watch: {
		playbook() {
			if (this.playbook) {
				this.$root.$emit("page-title:update", this.playbook.name);
			}
			this.parameters = new PlaybookPerformanceReport(this.playbook);
		},
	},
	// computed: {
	//     definitions() {
	//         let definitions = [];
	//         var definition = _.cloneDeep(this.parameters);
	//         definition.metric = this.metric;
	//         definitions.push(definition);
	//         return definitions;
	//     },
	// },
};
</script>
